var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default",_vm._l((_vm.items),function(item,index){return _c('oc-accordion-item',{key:index,attrs:{"item":item},scopedSlots:_vm._u([{key:"header",fn:function(ref){
var uniqueId = ref.uniqueId;
return [_vm._t("header",null,{"item":item,"uniqueId":uniqueId})]}},{key:"content",fn:function(ref){
var uniqueId = ref.uniqueId;
return [_vm._t("content",null,{"item":item,"uniqueId":uniqueId})]}}],null,true)})}))],2)}
var staticRenderFns = []

export { render, staticRenderFns }